import React from 'react'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
 
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import { Box,Card  ,CardContent ,IconButton,Tooltip,
    //Radio ,RadioGroup,FormLabel,FormControlLabel,Typography,TextField,SvgIcon,
    FormControl,InputLabel,Select as MaterialSelect } from '@material-ui/core'
 
const useStyles = makeStyles((theme)=>({
    root: {
      minWidth: 275,
    },     
   
  }));

const Tablero = () => {
    let history = useHistory();
    const classes = useStyles();
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {guardarGenerales}=React.useContext(GeneralesContext);  
 
    React.useEffect(()=>{                     
		const veriSesion =  () => 
        {            
            const usu= localStorage.getItem('UsuarioNom');
            const nvl= localStorage.getItem('Tipo');
             
            if(usu==null)
            {                                
                guardarUsuario([])						
                guardarGenerales([])     
                localStorage.clear();           
                history.push("/")	
            }
            else
            {
               
                if (usuario.length==0) 
                {
                    guardarUsuario({Nombre:usu,nivel:nvl});                                      
                }
                guardarGenerales({Titulo:'Tablero'})                     
            }
        }
       
	    veriSesion();	
        		
},[]);
    
 
 
const principal=()=>{
    //console.log(auxTotal);
        const token30 = localStorage.getItem('token30');
        const token20 = localStorage.getItem('token20');
        const auxtkn = token20.substring(token20.length-24,token20.length-1)
        //console.log(auxtkn);
        
    return(
    <Box display="flex"  style={{width:"82vw",height:"80vh"}} >            
        <iframe src={`https://lineaverde-board-qa.daduva.mx/agenda/${token30}/1`}   frameborder="0"
            style={{width:"100%", height:"100%"}}/>                             
    </Box>      
    )
}
    return (
        <div>
            {principal()}            
        </div>
    )
}

export default Tablero
